// e561c71c84520e04e36e4ce9b1e8000a0527df6f|className=CtaApi|type=angular|apiName=agent|apiEnumKey=Agent|operationHash=ff0492e12c7eb304354d768c3b59b5d3b28a6b7f|kind=api-js

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';
import { parseOkResponseFromJSON } from '../../../parsers/OkResponse';

import { parseCtaRequestToJSON } from '../../../parsers/CtaRequest';
import { parseCtaResponseFromJSON } from '../../../parsers/CtaResponse';

export class CtaApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags CtaApi
   * @name CtaApiExecute
   * @summary Execute a CTA action
   * @request POST:/customers/{customerId}/cta
   * @secure
   */
  execute(
    {
      customerId,
    },
    data,
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/cta`,
        route: '/customers/{customerId}/cta',
        method: 'POST',
        body: parseCtaRequestToJSON(data),
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseCtaResponseFromJSON,
    isContentArray: false,
  }),
      },
    );
  }

  static ɵfac = function CtaApi_Factory(t) { return new (t || CtaApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: CtaApi, factory: CtaApi.ɵfac, providedIn: 'root' });
}
